import { IFilterValueProps, useNormalizedFilterValue, useEllipsis } from '@diana/core';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { DATE_FORMAT } from '../../utils/dateUtils';

export const FilterValue = (props: IFilterValueProps) => {
  const normalized = useNormalizedFilterValue(props);
  return useEllipsis({ text: normalized, styles: { textTransform: 'none' } });
};

export const TimeRangeFilterValue = (props: IFilterValueProps & { preset: string }) => {
  const { t } = useTranslation('components/CalendarDatePicker');
  // @ts-ignore
  const preset = t(`buttons.${props.preset}`) as string;
  return (
    <span style={{ width: 'max-content' }}>
      {props.title}: {preset}
    </span>
  );
};

export const TimeRangeDateTimeValue = (props: IFilterValueProps) => {
  const startDate: any = props?.value[0]?.value
    ? DateTime.fromISO(props.value[0].value as string).toFormat(DATE_FORMAT)
    : null;

  const endDate: any = props?.value[1]?.value
    ? DateTime.fromISO(props.value[1].value as string).toFormat(DATE_FORMAT)
    : null;

  let showText = props.title;

  if (startDate && endDate) {
    showText = `Time range: ${startDate} - ${endDate}`;
  } else if (startDate) {
    showText = `Time range: ${startDate} -`;
  }

  return <span style={{ width: 'max-content' }}>{showText}</span>;
};
